<p-confirmDialog #confirmDialogRef>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      [label]="'ASSISTANCE_CARE_LOG_EDITOR.CONFIRM_YES' | transloco"
      class="p-button-danger"
      (click)="confirmDialogRef.onAccept()"
    ></button>
    <button
      pButton
      type="button"
      [label]="'ASSISTANCE_CARE_LOG_EDITOR.CONFIRM_NO' | transloco"
      class="p-button-secondary"
      (click)="confirmDialogRef.onReject()"
    ></button>
  </ng-template>
</p-confirmDialog>
@for (assignment of effectiveAssignments(); track trackByAssignmentId($index, assignment)) {
    <div class="assistant-section">
      <div class="assistant-header">{{ assignment.fullname }}</div>

      <p-table
        [value]="logsForAssistantMap().get(assignment.assistantId) ?? []"
        [rowTrackBy]="trackByLogId"
        styleClass="p-datatable-sm p-datatable-gridlines care-log-duration-table"
        editMode="cell"
        [scrollable]="false"
        (onEditInit)="onCellEditInit($event)"
        (onEditComplete)="onCellEditComplete($event)"
        (onEditCancel)="onCellEditCancel($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="care-log-task-col">{{ 'ASSISTANCE_CARE_LOG_EDITOR.TASK' | transloco }}</th>
            <th class="care-log-duration-col">{{ 'ASSISTANCE_CARE_LOG_EDITOR.DURATION_MIN' | transloco }}</th>
            @if (!readonly()) {
              <th class="care-log-action-col">{{ 'ASSISTANCE_CARE_LOG_EDITOR.ACTION' | transloco }}</th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log>
          <tr>
            <td class="care-log-task-col">{{ log.careTypeName }}</td>
            <td
              class="care-log-duration-col"
              [pEditableColumn]="log.id"
              pEditableColumnField="careDurationMinutes"
              [pEditableColumnDisabled]="readonly()"
            >
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    [ngModel]="log.careDurationMinutes"
                    (ngModelChange)="onDurationInputChange(log, $event)"
                    [showButtons]="false"
                    inputStyleClass="duration-input"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ log.careDurationMinutes }}
                </ng-template>
              </p-cellEditor>
              @if (rowErrors().has(log.id!)) {
                <div class="row-error-message">{{ rowErrors().get(log.id) | transloco }}</div>
              }
            </td>
            @if (!readonly()) {
              <td class="care-log-action-col">
                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger p-button-text p-button-sm"
                  (click)="removeLog(log)"
                  [pTooltip]="'ASSISTANCE_CARE_LOG_EDITOR.REMOVE' | transloco"
                ></button>
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="readonly() ? 2 : 3" class="empty-message">
              {{ 'ASSISTANCE_CARE_LOG_EDITOR.NO_TASKS' | transloco }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (!readonly() && canAddMoreTasks()) {
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          [label]="'ASSISTANCE_CARE_LOG_EDITOR.ADD' | transloco"
          class="p-button-sm add-button"
          (click)="openAdd(assignment.assistantId); $event.stopPropagation()"
        ></button>
      }

      @if (role() === 'assistant' && maxTotalMinutes() !== null) {
        <div class="minutes-summary">
          <span>{{ 'ASSISTANCE_CARE_LOG_EDITOR.TOTAL' | transloco }}: {{ totalMinutesForAssistant() }} min</span>
          <span>{{ 'ASSISTANCE_CARE_LOG_EDITOR.REMAINING_MINUTES' | transloco }}: {{ remainingMinutes() }} min</span>
        </div>
      }
    </div>
}
